var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"bv-swiper-scroll-container"},[_c('div',{staticClass:"bc-row bv-swiper-scroll",class:[
	       _vm.direction== 'x' && 'direction-x',
	       _vm.direction== 'y' && 'direction-y'
	     ]},[_vm._t("scroll-items",null,{"scrollTo":_vm.scrollTo})],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }